import APIConfiguration from '@savgroup-front-common/configuration/api';
import { logVerbose } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { addHttpsProtocolIfDoesNotExist } from '@savgroup-front-common/core/formatters/url';

import { AuthConfiguration } from './index';

async function fetchAuthorityUrl(): Promise<void> {
  try {
    const { clientId } = AuthConfiguration;

    const response = await fetch(
      `${APIConfiguration.config}sellers/idsUrl/${clientId}`,
    );

    const { value } = await response.json();

    const authority = addHttpsProtocolIfDoesNotExist(value);

    if (AuthConfiguration.setAuthority) {
      AuthConfiguration.setAuthority(authority);
    }
  } catch {
    logVerbose('Fallback default authority from static config.');
  }
}

export default fetchAuthorityUrl;
